import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./About.css";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const navigate = useNavigate();

  var homeBanner = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  const testimonial_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // below 1024px screen width
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768, // below 768px screen width
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480, // below 480px screen width
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const team_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // below 1024px screen width
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // below 768px screen width
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // below 480px screen width
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  return (
    <>
      <section className="yellow_bg overflow-hidden">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="about-content">
                <h1 className="font-semibold mb-2">Our Story</h1>
                <h4 className="font-semibold mb-4">
                  One Community. Endless Possibilities.
                </h4>
                <p className="font-semibold">
                  In 2020, the world faced an unprecedented crisis with Covid
                  lockdowns, but amid the chaos, street animals suffered the
                  most. With timely healthcare out of reach, many died of hunger
                  and thirst. Countless pets were abandoned, deprived of homes
                  and love they desperately needed.
                </p>
                <p className="font-semibold">
                  We started with small steps that made a big difference.
                  Feeding the animals outside our society turned into a mission.
                  We expanded to our entire neighborhood, partnering with
                  communities committed to rescuing and caring for street
                  animals.
                </p>
                <p className="font-semibold">
                  Soon, we realized it was time to take the next big step — to
                  create lasting change for these voiceless souls. That's how
                  Everything Pawzible was born — a one-stop destination
                  dedicated to supporting street animals and caring for your
                  beloved pets too. Together, we can make a world where every
                  paw gets the love, care, and home it deserves.
                </p>
                <p className="font-semibold">
                  Join us. Let's make Everything Pawzible!
                </p>
                <div className="pet-image-wrap">
                  <img
                    className="pet-image"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/about_img.png`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="team_slider">
        <div className="container">
          <h1 className="font-semibold mb-3 text-center mb-5">Our Team</h1>
          <div className="row">
            <div className="col-md-12">
              <Slider {...team_slider}>
                <div className="team-card">
                  <div className="team-image-container">
                    <img
                      className="team-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/team/Charu.png`}
                    />
                  </div>

                  <h3 className="mt-4 mb-1">Charulata Ravi Kumar</h3>
                  <p className="location">Head of Rescue Operations</p>
                </div>

                <div className="team-card">
                  <div className="team-image-container">
                    <img
                      className="team-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/team/Ravi.png`}
                    />
                  </div>

                  <h3 className="mt-4 mb-1">Ravi Venkatesan </h3>
                  <p className="location">Financial Advisor</p>
                </div>

                <div className="team-card">
                  <div className="team-image-container">
                    <img
                      className="team-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/team/Yash.png`}
                    />
                  </div>

                  <h3 className="mt-4 mb-1">Yashovat Gullapalli</h3>
                  <p className="location">CEO</p>
                </div>

                <div className="team-card">
                  <div className="team-image-container">
                    <img
                      className="team-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/team/R_vanitha.jpeg`}
                    />
                  </div>

                  <h3 className="mt-4 mb-1">R. Vanitha</h3>
                  <p className="location">Chief of Staff</p>
                </div>

                <div className="team-card">
                  <div className="team-image-container">
                    <img
                      className="team-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/team/balaji.jpeg`}
                    />
                  </div>

                  <h3 className="mt-4 mb-1">Balaji Venkatraman</h3>
                  <p className="location">Digital Specialist</p>
                </div>

               
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
